
export let correspondance_config = {
    genral_info: [
        { key: 'NAME', label: 'Name', packetType: 'OPERATION' },
        { key: 'LOC', label: 'Location', packetType: 'OPERATION' }
    ],
    information: [
        { key: 'OC', label: 'OC', packetType: 'OPERATION', unit: 'A' },
        { key: 'PC', label: 'PC', packetType: 'OPERATION', unit: 'A' },
        { key: 'VNO', label: 'VNO', packetType: 'OPERATION', unit: 'V' },
        { key: 'VRO', label: 'VRO', packetType: 'OPERATION', unit: 'V' },
        { key: 'OT', label: 'OT', packetType: 'OPERATION', unit: 'S' },
        { key: 'DATE', label: 'Date/Time', packetType: 'OPERATION', unit: 'TIMESTAMP' },
    ],
    field_status: [
        { key: 'S1GAP', label: 'NORMAL GAP S1', packetType: 'GAP', unit: 'MM' },
        { key: 'S2GAP', label: 'NORMAL GAP S2', packetType: 'GAP', unit: 'MM' },
        { key: 'S3GAP', label: 'REVERSE GAP S3', packetType: 'GAP', unit: 'MM' },
        { key: 'S4GAP', label: 'REVERSE GAP S4', packetType: 'GAP', unit: 'MM' },
        // { key: 'S1COND', label: 'S1COND', packetType: 'GAP' },
        // { key: 'S2COND', label: 'S2COND', packetType: 'GAP' },
        // { key: 'S3COND', label: 'S3COND', packetType: 'GAP' },
        // { key: 'S4COND', label: 'S4COND', packetType: 'GAP' },
        { key: 'DATE', label: 'Date/Time', packetType: 'GAP', unit: 'TIMESTAMP' },
    ],
    relay_room_status: [
        { key: 'RWKR', label: 'RWKR', packetType: 'DETECTION', unit: 'V' },
        { key: 'NWKR', label: 'NWKR', packetType: 'DETECTION', unit: 'V' },
        { key: 'DATE', label: 'Date/Time', packetType: 'DETECTION', unit: 'TIMESTAMP' },

    ]

}

